<template>
	<div class="flex duration-300 border-2 rounded-lg border-slate-300 focus-within:border-primary">
		<BaseTextInput
			type="autocomplete"
			:input-class="[
				'border-none rounded-0',
				state.isCountryCodeFocused ? 'bg-white' : 'bg-white hover:bg-slate-100 duration-300 cursor-pointer'
			]"
			theme-type="outlined"
			:class="['z-[11] flex-shrink-0 w-full', state.isCountryCodeFocused ? '' : 'max-w-[64px]']"
			:options="CountryDialInfo"
			option-display="flag"
			option-name="name"
			:value="selectedCountry"
			@update:value="
				(v) => {
					state.selectedCountry = v
					emit('update:modelValue', v.dial_code + mobileWithoutAreaCode)
				}
			"
			@focus="state.isCountryCodeFocused = true"
			@blur="state.isCountryCodeFocused = false"
			:start-icon="!state.isCountryCodeFocused && !areaCode ? 'ph:globe' : undefined"
			:end-icon="state.isCountryCodeFocused ? 'mdi:phone' : undefined"
		>
			<template #option="{ selected, option }">
				<div
					class="flex items-center w-full px-3 py-2 text-sm truncate duration-300 bg-white cursor-pointer hover:bg-slate-50 text-slate-900"
				>
					<span class="flex-shrink-0 me-2">
						{{ option.flag }}
					</span>
					<span class="flex-grow truncate">
						{{ option.name }}
					</span>
					<span class="flex-shrink-0 text-xs text-slate-600">
						{{ option.dial_code }}
					</span>
				</div>
			</template>
		</BaseTextInput>
		<div v-if="!state.isCountryCodeFocused" class="flex-shrink-0 my-2 border-e-[2px] border-slate-200" />
		<BaseTextInput
			v-if="!state.isCountryCodeFocused"
			type="number"
			class="flex-grow rounded-0"
			input-class="bg-white border-none"
			theme-type="outlined"
			:placeholder="$t('phone_number')"
			:value="mobileWithoutAreaCode"
			@update:value="(v) => emit('update:modelValue', areaCode + v)"
			end-icon="mdi:phone"
		/>
	</div>
</template>

<script setup lang="ts">
import CountryDialInfo from "~/assets/country-dial-info.json"

const emit = defineEmits<{
	"update:modelValue": [string]
}>()
const props = defineProps<{
	modelValue?: string
}>()

const state = reactive({
	isCountryCodeFocused: false,
	selectedCountry: null as (typeof CountryDialInfo)[number] | null
})

const areaCode = computed(() => {
	let m = String(props.modelValue || "")
	return CountryDialInfo.find((v) => m.includes(v.dial_code))?.dial_code || ""
})

const selectedCountry = computed(
	() => state.selectedCountry || CountryDialInfo.find((v) => v.dial_code == areaCode.value)
)

const mobileWithoutAreaCode = computed(() => {
	let m = String(props.modelValue || "")
	if (!areaCode.value) return m
	return m.replace(areaCode.value, "")
})
</script>
